<template>
  <div class="food-info-container">
    <transition :name="transitionName" mode="out-in">
      <FoodDetails
        v-if="showDetail"
        :food-details="foodDetails"
        :is-searching="isSearching"
        @hide-details="hideDetails"
      />
      <FoodLibrary 
        v-else
        :food-list="foodList"
        @get-food-details="getFoodDetails"
      />
    </transition>
  </div>
</template>

<script>

import FoodDetails from './FoodDetails'
import FoodLibrary from './FoodLibrary'

export default {
  name: "FoodInfo",
  components: {
    FoodDetails,
    FoodLibrary,
  },
  props: {
    foodList: {
      type: Array,
      default: function(){
        return []
      },
    },
    foodDetails: {
      type: Object,
      default: function(){
        return {};
      },
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      transitionName: "details-in",
      showDetail: false,
    };
  },
  methods: {
    hideDetails () {
      this.transitionName = "details-out"
      this.showDetail = false
    },
    getFoodDetails (id) {
      this.$emit("get-food-details", id)
      this.transitionName = "details-in"
      this.showDetail = true
    },
  },
};
</script>

<style scoped lang="scss">
  .details-in-enter-active, .details-in-leave-active, 
  .details-out-enter-active, .details-out-leave-active {
    transition: all 0.2s ease;
  }
  .details-in-enter, .details-out-leave-to {
    transform: translateX(30px);
    opacity: 0;
  }
  .details-in-leave-to, .details-out-enter {
    transform: translateX(-30px);
    opacity: 0;
  }
  .food-info-container {
    width: 100%;
    height: 100%;
  }
</style>